import React from "react";
import { generateLines, generatePoints, isMobileDevice } from "../../Utils/Utils";
import { Point } from "../../Utils/types";

type SizeProp = "lg" | "md" | "sm";
type LoaderProps = {
  blue?: boolean;
  size: SizeProp;
  backgroundWeb?: boolean;
};

const Loader: React.FC<LoaderProps> = ({
  blue = false,
  size,
  backgroundWeb = false,
}) => {
  const numPoints = isMobileDevice() ? 15 : 30; // Random number of points between 30 and 50
  const initialSpeed = 0.2; // Adjust this value to control the initial movement speed
  const circlePoints: Point[] = generatePoints({ numPoints, initialSpeed });
  const lines = generateLines(circlePoints, blue ? "rgba(7,68,129,0.1)" : "rgba(255, 255, 255, 0.10)");

  return (
    <div className="loader">
      {backgroundWeb && (
        <>
          <div className={`background ${blue && "blue"}`}></div>
          <svg className="web" xmlns="http://www.w3.org/2000/svg">
            <g className="lines">{lines}</g>
            {circlePoints.map((point, index) => (
              <circle
                key={index}
                cx={`${point.x}%`}
                cy={`${point.y}%`}
                r={3}
                fill={
                  blue ? "rgba(7,68,129,0.45)" : "rgba(255, 255, 255, 0.45)"
                }
                className="moving-point"
              />
            ))}
          </svg>
        </>
      )}
      <div className={`center ${size}`}>
        <div className={`spinner ${blue && "blue"} ${size}`}></div>
        <div className={`letter ${blue && "blue"} ${size}`}></div>
      </div>
    </div>
  );
};

export default Loader;
